var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaste(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 0C7.39543 0 6.5 0.89543 6.5 2V3H4.5V5C4.5 5.55228 4.94772 6 5.5 6H13.5C14.0523 6 14.5 5.55228 14.5 5V3H12.5V2C12.5 0.895431 11.6046 0 10.5 0H8.5ZM8.5 3C8.5 2.44772 8.94771 2 9.5 2C10.0523 2 10.5 2.44772 10.5 3C10.5 3.55228 10.0523 4 9.5 4C8.94771 4 8.5 3.55228 8.5 3Z",
    fill: "#414042"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4H3.5V5C3.5 6.10457 4.39543 7 5.5 7H13.5C14.6046 7 15.5 6.10457 15.5 5V4H18.5V11H8.5V22H2.5C1.39543 22 0.5 21.1046 0.5 20V4Z",
    fill: "#414042"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 12H22.5V24H9.5V12ZM20.5 14H11.5V16H20.5V14ZM20.5 18H11.5V20H20.5V18Z",
    fill: "#414042"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaste);
export default __webpack_public_path__ + "static/media/Paste.ce3857683881bb9f300c92443f0a4496.svg";
export { ForwardRef as ReactComponent };